import { gql } from '@apollo/client'

export const CORE_COACHING_KIND_FIELDS = gql`
  fragment CoreCoachingKindFields on CoachesCoachingKindDef {
    key
    coachTitle
    shortCoachTitle
    hubTitle
    shortHubTitle
    serviceTitle
    clinical
    insuranceReimbursable
    primary
  }
`
